import { render } from "./AchievementHolder.vue?vue&type=template&id=c0b81c30"
import script from "./AchievementHolder.vue?vue&type=script&lang=js"
export * from "./AchievementHolder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/connorklaassen/Documents/Programming/cklaassen.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__